import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import Table from './StaticNumberPage';
import DynamicPool from './DynamicPool';
import DynamicPoolNumbers from './DynamicPoolNumbers';
import Reports from './ReportsPage';
import { useHistory } from 'react-router-dom';
import Acknowledgment from './Acknowledgment';
import QuicksightPage from './QuickSightPage';

const TABS = ['numbers', 'dynamicNumbers'];

const Dashboard = ({ onLogout }) => {
  const history = useHistory();
  // Ansible ('sms') moved to Pulse; a saved tab that no longer exists falls back to Static Numbers.
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem('activeTab');
    return TABS.includes(savedTab) ? savedTab : 'numbers';
  });
  const [acknowledgment, setAcknowledgment] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedPool, setSelectedPool] = useState(null);
  const [email, setEmail] = useState('Loading...');
  const [name, setName] = useState('Loading...');

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setEmail(user.attributes.email); // Get the email from the CognitoUser attributes
        setName(user.attributes.name || user.username); // Fallback to username if name is not available
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUserDetails();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const handlePoolSelect = (poolName) => {
    setSelectedPool(poolName);
    setActiveTab('dynamicNumbers');
  };

  const handleAcknowledgmentClose = () => {
    setAcknowledgment('');
    history.push('/dashboard');
  };

  const handleSignOut = async () => {
    await Auth.signOut();
    onLogout();
    localStorage.removeItem('authenticated');
    history.push('/');
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  return (
    <div className="container mx-auto mt-8">
      <div className="flex justify-between items-center mb-4">
        {/* Tabs */}
        <div>
          <button
            className={`tab-btn ${activeTab === 'numbers' ? 'active' : ''}`}
            onClick={() => handleTabChange('numbers')}
          >
            Static Numbers
          </button>
          <button
            className={`tab-btn ${activeTab === 'dynamicNumbers' ? 'active' : ''}`}
            onClick={() => handleTabChange('dynamicNumbers')}
          >
            Dynamic Pools
          </button>
          {/* <button
            className={`tab-btn ${activeTab === 'analytics' ? 'active' : ''}`}
            onClick={() => handleTabChange('analytics')}
          >
            Analytics
          </button> */}
        </div>

        {/* Profile Section */}
        <div className="relative">
          <div
            className="flex items-center px-4 py-2 bg-gray-50 border border-gray-300 rounded-full shadow-sm cursor-pointer hover:shadow-md"
            onClick={toggleDropdown}
          >
            <div className="w-8 h-8 flex justify-center items-center bg-gray-100 rounded-full mr-3">
              <span className="text-gray-600 text-lg">👤</span>
            </div>
            <p className="font-medium text-gray-800">Hi, {name}</p>
            <span className="ml-2 transform transition-transform duration-200">
              {isDropdownOpen ? '▲' : '▼'}
            </span>
          </div>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-50 bg-white border border-gray-300 rounded-md shadow-lg z-10">
              <div className="px-4 py-2">
                <p className="text-sm text-gray-700">
                  <span className="font-semibold">Email:</span> {email || '-'}
                </p>
              </div>
              <button
                onClick={handleSignOut}
                className="block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>

      </div>

      {/* Tab Content */}
      {activeTab === 'numbers' && (
        <div className="p-4 bg-white rounded shadow mb-4">
          <Table setAcknowledgment={setAcknowledgment} />
        </div>
      )}
      {activeTab === 'dynamicNumbers' && (
        <div className="p-4 bg-white rounded shadow mb-4">
          {selectedPool ? (
            <DynamicPoolNumbers selectedPool={selectedPool} />
          ) : (
            <DynamicPool onPoolSelect={handlePoolSelect} />
          )}
        </div>
      )}
      {/* {activeTab === 'analytics' && (
        <div className="p-4 bg-white rounded shadow">
          <QuicksightPage />
        </div>
      )} */}
      {acknowledgment && (
        <Acknowledgment
          onClose={handleAcknowledgmentClose}
          acknowledgment={acknowledgment}
        />
      )}

      {/* Styles */}
      <style>
        {`
          .tab-btn {
            padding: 0.5rem 1rem;
            background-color: transparent;
            border: none;
            cursor: pointer;
            font-size: 1rem;
            font-weight: bold;
            text-decoration: none;
            transition: all 0.3s ease;
            margin: 0 0.5rem;
          }

          .tab-btn.active {
            color: #0000FF;
            position: relative;
          }

          .tab-btn.active::after {
            content: '';
            position: absolute;
            bottom: -3px;
            left: 50%;
            transform: translateX(-50%);
            width: 40%;
            height: 2px;
            background-color: #0000FF;
          }
        `}
      </style>
    </div>
  );
};

export default Dashboard;
